<template>
  <highcharts :options="chart_options"></highcharts>
</template>

<script>
import { Chart } from "highcharts-vue";
import moment from "moment";
import Highcharts from "highcharts/highcharts.js"

export default {
  name: "bar_chart_horizontal",
  components: {
    highcharts: Chart,
  },
  props: {
    data: Object,
    reversed: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      chart_options: {},
      id_project: this.$store.getters.user.id_project,
      topics: {},
      topics_form: {},
    };
  },
  mounted() {
    this.loadChart();
    this.getTopics();
  },
  methods: {
    getTopics: function () {
      let self = this;
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.$http
        .get(api)
        .then(function (response) {
          let resp = response.data;

          // sosmed topic
          let topik = [];
          let tpk;
          for (var key in resp.socmed) {
            tpk = {
              id: key,
              text: resp.socmed[key],
              category: "medsos",
            };
            topik.push(tpk);
          }
          self.topics = topik;

          // formed topic
          let topik_form = [];
          let tpk_form;
          for (var key1 in resp.formed) {
            for (var key2 in resp.formed[key1]['topics']) {
              tpk_form = {
                id: key2,
                text: resp.formed[key1]['group_name'],
                category: "medkon",
              };
            }
            topik_form.push(tpk_form);
          }
          self.topics_form = topik_form;

        })
        .catch(function (err) {
          self.err = err.response;
        });
    },
    loadChart() {
      let data = this.data
      let self = this
      this.chart_options = {
        chart: {
          type: "bar",
          backgroundColor: "transparent",
        },
        title: {
          text: " ",
        },
        colors: [
        "#4572A7", "#28a745", "#343a3f", "#ffc007", "#dc3444"
        ],
        credits: {
          enabled: false,
        },
        xAxis: {
          categories: this.data.x,
        },
        yAxis: {
          min: 0,
          title: {
            text: "Total",
          },
        },
        tooltip: {
          // pointFormat:
          //   '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.y})<br/>',
          shared: true,
          formatter: function () {
            var s = '<span>' + this.series.name + '</span> :'
              + Highcharts.numberFormat(this.point.y, 0, ',', ',')
            // + ' (' + Math.round(this.point.percentage) + '%)';
            return s;
          }
        },
        legend: {
          layout: "horizontal",
          align: "center",
          verticalAlign: "bottom",
          maxHeight: 100,
          reversed: this.reversed,
        },
        plotOptions: {
          series: {
            // stacking: "percent",
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              style: {
                textOutline: false
              },
              format: "{point.y}",
            },
            label: {
              connectorAllowed: false,
            },
            point: {
              events: {
                click: function (event) {
                  let source = data.source
                  let query = data.query
                  let start = "";
                  let end = "";
                  let params = {};
                  let tgl = this.category.split(" ");
                  let tgl_str = tgl[2] + "-" + tgl[1] + "-" + tgl[0];
                  tgl = moment(tgl_str, "YYYY-MMM-DD");
                  if (tgl.isValid()) {
                    start = tgl.format("YYYY-MM-DD 00:00:00");
                    end = tgl.format("YYYY-MM-DD 23:59:59");
                  } else {
                    start = moment(self.$route.query.from).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                    end = moment(self.$route.query.to).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                  }

                  params = {
                    from: start,
                    to: end,
                  };

                  if ("cakupan" in self.$route.query) {
                    params.cakupan = self.$route.query.cakupan;
                  }

                  if (source) {
                    params.sources = btoa(source);
                  }

                  if (query) {
                    params.q = query;
                  }

                  // cek bar yang di klik dengan topic yang tersedia
                  function matchData(dataArray, value) {
                    for (let i = 0; i < dataArray.length; i++) {
                      if (dataArray[i].text === value) {
                        return dataArray[i];
                      }
                    }
                    return null;
                  }
                  function matchData_form(dataArray, value) {
                    for (let i = 0; i < dataArray.length; i++) {
                      if (dataArray[i]) {
                        if (dataArray[i].text === value) {
                          return dataArray[i];
                        }
                      }
                    }
                    return null;
                  }

                  if (data.source == "news") {
                    const matchedObject = matchData_form(self.topics_form, event.point.category);
                    if (matchedObject) {
                      params.topic_selected = btoa(matchedObject['id']);
                    }
                  } else {
                    const matchedObject = matchData(self.topics, event.point.category);
                    if (matchedObject) {
                      params.topic_selected = btoa(matchedObject['id']);
                    }
                  }
                  self.$router.push({ path: "/posts", query: params });
                },
              },
            },
          },
        },
        series: this.data.y,
      };
    },
  },
};
</script>